//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  DEAL_PLACEHOLDER_IMG,
  BLACK_FRIDAY_SLUG,
  BLACK_FRIDAY_PARTICIPATION_SLUG,
  BLACK_FRIDAY_LAST_CALL_SLUG,
  BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
  SUMO_DAY_SLUG,
  SUMO_DAY_PARTICIPATION_SLUG,
  LAST_CALL_SLUG,
  LAST_CALL_PARTICIPATION_SLUG,
} from '@/constants/global';
import get from 'lodash/get';
import VLazyImage from 'v-lazy-image';
import BlackFridayBadge from '~/static/campaigns/black-friday-badge.svg?inline';
import SumoDayBadge from '~/static/sumoday-badge.svg?inline';
import DealBanner from '../utilities/DealBanner.vue';
import DealRating from '../utilities/DealRating.vue';

export default {
  components: {
    BlackFridayBadge,
    DealBanner,
    DealRating,
    SumoDayBadge,
    VLazyImage,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    hasBanner() {
      // Taken from DealBanner.vue
      return (
        this.deal.browse_deal_status === 'expired'
        || (this.deal.shows_codes_remaining && this.deal.codes_remaining > 0)
        || (
          this.deal.browse_deal_status === 'current'
          && this.deal.dates
          && this.deal.dates.end_date
          && this.deal.has_started
          && this.deal.active_timer
        )
        || this.isComingSoon
      );
    },
    campaigns() {
      if (this.$store && this.$store.getters) {
        return this.$store.getters.campaigns || [];
      }
      return [];
    },
    isSumoDay() {
      return this.isParticipatingAndActive(SUMO_DAY_SLUG, SUMO_DAY_PARTICIPATION_SLUG);
    },
    isBlackFriday() {
      return this.isParticipatingAndActive(BLACK_FRIDAY_SLUG, BLACK_FRIDAY_PARTICIPATION_SLUG);
    },
    isBlackFridayLastCall() {
      return this.deal.buy_button?.is_last_call === true
          && this.isParticipatingAndActive(
            BLACK_FRIDAY_LAST_CALL_SLUG,
            BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
          );
    },
    isLastCall() {
      // jl: the isParticipatingAndActive check is needed until separate handling is created for
      // extended access, plus exclusives, and plus freebies. the check can and should be removed
      // once this functionality has been built and existing deals have been transferred over
      return this.deal.buy_button?.is_last_call === true
          && this.isParticipatingAndActive(LAST_CALL_SLUG, LAST_CALL_PARTICIPATION_SLUG);
    },
    isLimitedTimeSale() {
      return this.isLastCall || this.isBlackFridayLastCall;
    },
    dealUrl() {
      return `${this.deal.get_absolute_url}?ref=best-match`;
    },
  },
  methods: {
    onClickTile(isNewWindow = false) {
      if (isNewWindow) {
        window.open(this.deal.get_absolute_url);
      } else {
        window.location = this.deal.get_absolute_url;
      }
    },
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
    isParticipatingAndActive(campaignSlug, participationSlug) {
      const isCampaignActive = this.campaigns.includes(campaignSlug);
      return isCampaignActive && this.deal.participation?.includes(participationSlug);
    },
  },
};
